import React from 'react'
import CIcon from '@coreui/icons-react'
import {
  cilBell,
  cilCalculator,
  cilCalendar,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilEnvelopeOpen,
  cilGrid,
  cilLayers,
  cilMap,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilSpreadsheet,
  cilStar,
} from '@coreui/icons'
import { CNavGroup, CNavItem, CNavTitle } from '@coreui/react-pro'

const _navSales = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/dashboard',
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    badge: {
      color: 'info-gradient',
    },
  } /*
  {
    component: CNavGroup,
    name: 'Users',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Group Users',
        to: '/linkusers',
      },
    ],
  },*/,
  {
    component: CNavGroup,
    name: 'Admin',
    icon: <CIcon icon={cilPuzzle} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: 'Add Admin',
        to: '/addadmin',
      },
      {
        component: CNavItem,
        name: 'Update Admin',
        to: '/updateadmin',
      },
      {
        component: CNavItem,
        name: 'View Admin',
        to: '/viewadmin',
      },
      {
        component: CNavItem,
        name: 'Users Permission',
        to: '/permuser',
      },
      {
        component: CNavItem,
        name: 'Activity Log',
        to: '/log',
      },
      /*{
          component: CNavItem,
          name: 'Group Users',
          to: '/linkusers',
        },*/
    ],
  },
  {
    component: CNavItem,
    name: 'Log out',
    to: '/logout',
    icon: <CIcon icon={cilDrop} customClassName="nav-icon" />,
  },
]

export default _navSales
